import { render, staticRenderFns } from "./SpreadsheetPreview.vue?vue&type=template&id=ccb35efa&scoped=true&"
import script from "./SpreadsheetPreview.vue?vue&type=script&lang=js&"
export * from "./SpreadsheetPreview.vue?vue&type=script&lang=js&"
import style0 from "./SpreadsheetPreview.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SpreadsheetPreview.vue?vue&type=style&index=1&id=ccb35efa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb35efa",
  null
  
)

export default component.exports